/*
 * File: InputSelect.js
 * Project: mp-mobile-app
 *
 * Created by Rob Rothe
 *
 * Copyright (c) 2019 MacPractice, Inc. All rights reserved.
 *
 * Description: Form builder select field
 */
import React from "react";
import PropTypes from "prop-types";
import { observer } from "mobx-react";
import UISelect from "components/ui/UISelect";

const InputSelect = ({ field, value, error, parentOnChange, parentOnBlur }) => {
  return (
    <UISelect
      options={field.options}
      label={field.label}
      value={value}
      parentOnChange={parentOnChange}
      parentOnBlur={parentOnBlur}
      error={error}
      name={field.name}
      disabled={field.disabled}
    />
  );
};

InputSelect.propTypes = {
  field: PropTypes.object.isRequired,
  error: PropTypes.bool,
  parentOnChange: PropTypes.func.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  parentOnBlur: PropTypes.func.isRequired
};

export default observer(InputSelect);
